<template>
    <div class="atelier-swipper-container global-limited-1360px-container" :class="{ '': isMobile }">
        <div class="atelier-swipper-title">
            <CommonComponentsProductsTitleTopicTitle :topic-title="topicTitle" :color-index="data.colorIndex" />
        </div>
        <CommonComponentsProductsDownload product="atelier" size="small" class="swipper-download" />
        <div class="atelier-swipper-clothing" @click.prevent>
            <img :src="data.bg" alt="" class="atelier-bg" />
            <picture>
                <!-- <source media="(max-width: 750px)" :srcset="data.glassmobile" /> -->
                <!-- 懒加载 -->
                <img :data-src="data.character" class="lazy atelier-character" alt="" />
            </picture>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import atelierBg from '@assets/imgs/Products/Atelier/Swipper/atelier.png';
    import atelierCharacter from '@assets/imgs/Products/Atelier/Swipper/atelier_character.png';
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    import { ifCNLocale } from '~~/composables/useLocale.ts';

    gsap.registerPlugin(ScrollTrigger);

    const isCN = ifCNLocale();
    const isMobile = ref(false);

    const data = reactive({
        bg: atelierBg,
        character: atelierCharacter,
        colorIndex: 4,
    });
    const topicTitle: FunctionTitle = {
        title: 'global_swipper_title',
        colorTitle: 'global_studio_swipper_colorTitle_3',
        subTitle: 'global_home_header_submenu_link_0_5_des',
    };

    onMounted(() => {
        isMobile.value = matchMobile();
        gsap.timeline({
            scrollTrigger: {
                trigger: '.atelier-swipper-clothing',
                scrub: true,
                start: 'center center',
                end: '70% top',
            },
        }).fromTo(
            '.atelier-character',
            {
                xPercent: -50,
                x: 0,
                transformOrigin: '50% 100%',
            },
            {
                scale: 0.8,
            },
        );
    });
</script>

<style lang="less" scoped>
    .atelier-swipper-container {
        @media (max-width: @screen-mobile-width) {
            width: 100vw;
            height: 100vh;

            display: flex;
            flex-direction: column;
        }
        .atelier-swipper {
            &-title {
                padding-top: .convert(106px) [ @vw];
                width: 100%;
            }

            &-clothing {
                position: relative;
                height: .convert(950px) [ @vw];
                pointer-events: none;

                @media (max-width: @screen-mobile-width) {
                    flex-grow: 1;
                }
                .atelier-bg {
                    position: absolute;
                    width: 100%;
                    height: auto;
                    top: 25%;
                    transform: translateY(-50%);

                    @media (max-width: @screen-mobile-width) {
                        top: 35%;
                    }
                }
                .atelier-character {
                    height: .convert(1002px) [ @vw];
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    z-index: 0;
                }
                @media (max-width: @screen-mobile-width) {
                    .atelier-character {
                        margin-top: 5%;
                        height: 90%;
                        flex-shrink: 0;
                    }
                }
            }
        }

        .swipper-download {
            margin-top: .convert(20px) [ @vw];
            margin-bottom: .convert(5px) [ @vw];

            @media (max-width: @screen-mobile-width) {
                margin-top: .convert(10px) [ @vw-mobile];
                margin-bottom: 0px;
            }
        }
    }
</style>
